<template>
<div class="card">
    <div class="card-body">
        <div class="row d-flex justify-content-between align-items-center">
            <div class="col-auto">
                <h4 class="mt-0 d-flex align-items-center">
                    <div class="badge p-1" :class="statusClass" style="margin-top: -0.2rem;">{{ statusText }}</div>
                    <span class="ms-2">
                        {{ room.name }}
                    </span>
                </h4>
            </div>
            <div class="col-auto" v-if="guest.pay_btn_view && currentMonthPayment">
                <input type="checkbox" :id="`switch_${idx}`" :data-switch="payOnLabelColor" :checked="guest.is_checked" @change="changePayment($event)" />
                <label :for="`switch_${idx}`" :data-on-label="payOnLabel" :data-off-label="payOffLabel" class="mt-n1"></label>
            </div>
        </div>
        <div class="card mt-2">
            <div class="card-body">
                <!-- 계약자가 한명이라도 존재할 때 -->
                <template v-if="contractExist">
                    <h4 class="card-title d-flex align-items-center" style="font-size: 1rem;" @click.stop>
                        <input type="checkbox" class="form-check-input me-2" :id="`guest_box_${idx}`" style="margin-top: -0.1rem;" @click.stop>
                        <label :for="`guest_box_${idx}`" class="fw-bold">
                            <i class="mdi" :class="genderClass"></i> {{ guest.name }}
                        </label>
                        <span class="ms-1 font-12 fw-light" :class="leftDateClass" v-if="guest.status === 'entrance'">
                            (남은 일 수 : {{ leftDate }})
                        </span>
                        <span class="ms-1 font-12 fw-light" v-if="guest.status === 'expired'">
                            ({{ emptyDate }})
                        </span>
                    </h4>
                    <ul class="list-group list-group-flush" @click="$emit('open-view-modal', room)">
                        <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                            <span class="fw-bold"><i class="mdi mdi-calendar-month-outline"></i>&nbsp;기간</span> : {{ contractDate }}
                            <span class="ms-1 font-12 fw-light">
                                {{ checkDate }}
                            </span>
                        </a>
                        <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                            <span class="fw-bold"><i class="mdi mdi-calendar-check-outline"></i>&nbsp;수납일</span> : 매월 {{ textMonthPayDate }}
                        </a>
                        <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                            <span class="fw-bold"><i class="mdi mdi-credit-card-outline"></i>&nbsp;월 수납 금액</span> : {{ totalPrice }}만원
                        </a>
                        <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                            <span class="fw-bold"><i class="mdi mdi-cellphone"></i>&nbsp;</span>{{ guest.phone_no }}
                            <span class="badge badge-info-lighten py-1 ms-1 me-1">
                                <a :href="`tel:${guest.phone_no}`" @click.stop>
                                    <i class="mdi mdi-phone-outline"></i> 전화
                                </a>
                            </span>
                            <span class="badge badge-secondary-lighten py-1" @click.stop=test()>
                                <i class="mdi mdi-message-outline"></i> 메시지
                            </span>
                        </a>
                    </ul>
                </template>
                <!-- 계약자가 없을 때 -->
                <template v-else>
                    <div @click="$emit('open-register-modal', room, false)">
                        <h4 class="card-title">&nbsp;</h4>
                        <ul class="list-group list-group-flush text-center fw-bold">
                            <a href="javascript:void(0);" class="list-group-item border-0 py-1">
                                &nbsp;
                            </a>
                            <a href="javascript:void(0);" class="list-group-item border-0 text-muted">
                                <span class="font-15">등록된 계약이 존재하지 않습니다.</span>
                            </a>
                            <a href="javascript:void(0);" class="list-group-item border-0">
                                <button type="button" class="btn btn-outline-info fw-bold font-14 mt-2">
                                    계약 추가
                                </button>
                            </a>
                            <a href="javascript:void(0);" class="list-group-item border-0 py-1">
                                &nbsp;
                            </a>
                        </ul>
                    </div>
                </template>
            </div>
        </div>
        <div class="btn-group dropdown float-end" v-if="contractExist">
            <button type="button" class="btn btn-sm btn-outline-light" @click="$emit('open-register-modal', room, false)">
                <i class="mdi mdi-home-import-outline me-1"></i>계약 추가
            </button>
            <a href="#" class="table-action-btn dropdown-toggle arrow-none btn btn-light btn-sm" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="mdi mdi-format-list-bulleted"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-end" data-popper-placement="bottom-end">
                <a class="dropdown-item" @click="$emit('open-view-modal', room)">
                    <i class="mdi mdi-file-outline me-1"></i>계약 상세 보기
                </a>
                <a class="dropdown-item" @click="$emit('open-register-modal', room, true)">
                    <i class="mdi mdi-file-edit-outline me-1"></i>계약 수정
                </a>
                <div class="dropdown-divider m-1"></div>
                <a class="dropdown-item text-danger" @click="$emit('open-del-modal', room)">
                    <i class="mdi mdi-delete-alert-outline me-1"></i>계약 삭제
                </a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    DATE_FORMAT,
    DATE_DIFF
} from "@/config/date.js";
import dayjs from "dayjs";

export default {
    props: ["room", "today", "idx"],
    async mounted() {
        const payment = this.currentMonthPayment;

        if (payment) {
            // * 완납인 경우
            const condition_1 = payment.paid_status === "PAID_COMPLETE";

            // * 수납 이력이 존재하면서, 수납 토탈 금액이 0 이상일 경우
            const condition_2 = payment.paid_at && payment.paid_total > 0;

            if (condition_1 || condition_2) {
                this.room.recent_guest.is_checked = true;
            } else {
                this.room.recent_guest.is_checked = false;
            }
        } else {
            this.room.recent_guest.is_checked = false;
        }
    },
    computed: {
        guest() {
            return this.room.recent_guest;
        },
        genderClass() {
            return this.guest.gender === "M" ? "mdi-face-man-outline" : "mdi-face-woman-outline";
        },
        statusClass() {
            switch (this.guest.status) {
                case "entrance":
                    return "bg-success";
                case "expired":
                    return "bg-danger";
                case "waiting":
                    return "bg-primary";
                default:
                    return "bg-secondary";
            }
        },
        statusText() {
            switch (this.guest.status) {
                case "entrance":
                    return "입실";
                case "expired":
                    return "공실";
                case "waiting":
                    return "예약";
                default:
                    return "알 수 없음";
            }
        },
        currentMonthPayment() {
            const currentMonth = this.today.format("YYYY-MM");
            return this.guest.guest_payment.find(payment => payment.paid_year_month === currentMonth);
        },
        payOnLabel() {
            const payment = this.currentMonthPayment;

            if (!payment) {
                return "수납";
            }

            // 완납인 경우
            if (payment.paid_status === "PAID_COMPLETE") {
                return payment.paid_total > this.totalPrice ? "초과" : "수납";
            }

            // 수납 이력이 존재하고, 토탈 금액이 0 이상일 떄
            if (payment.paid_at && payment.paid_total > 0) {
                return "일부";
            }

            return "수납";
        },
        payOnLabelColor() {
            const payment = this.currentMonthPayment;

            if (!payment) {
                return "success";
            }

            // 완납인 경우
            if (payment.paid_status === "PAID_COMPLETE") {
                return payment.paid_total > this.totalPrice ? "primary" : "success";
            }

            // 수납 이력이 존재하고, 토탈 금액이 0 이상일 떄
            if (payment.paid_at && payment.paid_total > 0) {
                return "warning";
            }

            return "success";
        },
        payOffLabel() {
            const payment = this.currentMonthPayment;

            if (!payment || payment.paid_status === "PAID_COMPLETE") {
                return ""; // 결제 정보가 없거나 완납 상태인 경우 빈 문자열 반환
            }

            // 수납 예정일이 오늘보다 이전인 경우는 "미납", 오늘보다 이후면 "수납 예정"
            return dayjs(payment.paid_date).isBefore(this.today, "day") ? "미납" : "예정";
        },
        emptyDate() {
            return `${DATE_DIFF( this.guest.end_date, this.today)}일째 공실`;
        },
        leftDate() {
            return this.guest.end_date ? `${DATE_DIFF(this.today, this.guest.end_date) + 1}일` : "미정";
        },
        leftDateClass() {
            const remainingDays = this.guest.end_date ? DATE_DIFF(this.today, this.guest.end_date) + 1 : null;
            return remainingDays !== null && remainingDays <= 3 ? "text-danger fw-bold" : "";
        },
        checkDate() {
            let diff = "";
            switch (this.guest.status) {
                case "entrance":
                    diff = DATE_DIFF(this.guest.start_date, this.today) + 1;
                    return `(${diff}일째 거주 중)`;
                case "expired":
                    if (this.guest.end_date) {
                        diff = DATE_DIFF(this.guest.start_date, this.guest.end_date);
                        return `(${diff}일 거주 후, 퇴실)`;
                    }
                    return "";
                case "waiting":
                    diff = DATE_DIFF(this.today, this.guest.start_date) + 1;
                    return `(입주 D-${diff})`
                default:
                    return "";
            }
        },
        contractExist() {
            return this.guest.hasOwnProperty("pk");
        },
        contractDate() {
            if (this.guest.start_date) {
                return `${DATE_FORMAT(this.guest.start_date, "short")} ~ ${this.guest.end_date ? DATE_FORMAT(this.guest.end_date, "short") : "종료일 미정"}`;
            } else {
                return "";
            }
        },
        totalPrice() {
            const price = this.guest.price || 0;
            const maintenance = this.guest.maintenance_price || 0;
            let total = price + maintenance;

            if (this.guest.vat === "vat_price") {
                total = (price * 1.1) + maintenance;
            } else if (this.guest.vat === "vat_all") {
                total = (price + maintenance) * 1.1;
            }

            return Number.isInteger(total) ? total : total.toFixed(1);
        },
        textMonthPayDate() {
            return `${this.guest.month_pay_date}일${this.guest.month_pay_date === 31 ? " (말일)" : ""}`;
        }
    },
    methods: {
        test() {
            alert("카카오톡 메시지 기능은 현재 준비 중입니다");
        },
        changePayment(event) {
            const checked = event.target.checked;
            event.target.checked = this.guest.is_checked;
            this.$emit("toggle-payment", this.room, this.currentMonthPayment, checked);
        }
    }
}
</script>

<style>
.bg-orange {
    background-color: #FFA500;
}
</style>
